/**
 * @generated SignedSource<<2c9a416112e3bed4c41b26a4d887a703>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary$data = {
  readonly " $fragmentSpreads": FragmentRefs<"actionMenu_softwareReleasesVersionDetailIssueList_jiraIssueSummary">;
  readonly " $fragmentType": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary";
};
export type addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary$key = {
  readonly " $data"?: addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssueSummary"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "f26b20a2f8e5f0c916921d8c8691c202";

export default node;
